import { Var } from "addeus-common-library/stores/firestore";
import { Collection } from "addeus-common-library/stores/firestore/collection";
import { Entity } from "addeus-common-library/stores/firestore/entity";
import moment from "moment-with-locales-es6";

export enum TaskType {
    AddPhoto = "AddPhoto",
    Answer = "Answer",
    Validation = "Validation",
    AddDescription = "AddDescription",
    AddDate = "AddDate",
}

@Collection({
    namespace: "Task",
})
export class Task extends Entity {
    @Var(String)
    title?: string;

    @Var(String)
    description?: string;

    @Var(TaskType)
    type?: TaskType;

    @Var(String)
    postId: string | null = null;

    @Var(moment)
    date: moment;

    @Var(moment)
    validatedAt?: moment;

    @Var(String)
    question?: string;

    @Var(String)
    answer?: string;
}
